import React, {useState} from 'react';
import '../Assets/css/Contact.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Contact() {
  type ErrorFields = {
      entreprise?: string;
      contact?: string;
      message?: string;
  }
  const [message, setMessage] = useState('');
  const [entreprise, setEntreprise] = useState('');
  const [contact, setContact] = useState('');
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [errors, setErrors] = useState<ErrorFields>({});
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL as string;


  const handleMessageChange = (e) => {
    setMessage(e.target.value);
    if (attemptedSubmit) {
      setErrors(prev => {
        const next = { ...prev };
        if (!e.target.value.trim()) next.message = "Veuillez entrer un message.";
        else delete next.message;
        return next;
      });
    }
  }

  const handleEntrepriseChange = (e) => {
    setEntreprise(e.target.value);
    if (attemptedSubmit) {
      setErrors(prev => {
        const next = { ...prev };
        if (!e.target.value.trim()) next.entreprise = "Veuillez entrer le nom de votre entreprise.";
        else delete next.entreprise;
        return next;
      });
    }
  }

  const handleContactChange = (e) => {
    setContact(e.target.value);
    if (attemptedSubmit) {
      setErrors(prev => {
        const next = { ...prev };
        if (!e.target.value.trim()) next.contact = "Veuillez entrer votre adresse courriel.";
        else if (!validateEmail(e.target.value)) next.contact = "Veuillez entrer une adresse courriel valide.";
        else delete next.contact;
        return next;
      });
    }
  }

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setAttemptedSubmit(true);
    let newErrors: ErrorFields = {};
    if (!entreprise.trim()) {
      newErrors.entreprise = "Veuillez entrer le nom de votre entreprise.";
    }
    if (!message.trim()) {
      newErrors.message = "Veuillez entrer un message.";
    }
    if (!contact.trim()) {
      newErrors.contact = "Veuillez entrer votre adresse courriel.";
    }
    else if(!validateEmail(contact)){
      newErrors.contact = "Veuillez entrer une adresse courriel valide.";
    }
    setErrors(newErrors);

    if(Object.keys(newErrors).length > 0) {
      return;
    }

    try{
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-text-message-x': message,
          'x-client-contact-x': contact,
          'x-client-enterprise-x': entreprise
        }
      })
      if (!res.ok) {
        setFail(true);
        setTimeout(() => {setFail(false);}, 10000);
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      if (Object.keys(newErrors).length === 0) {
        setSuccess(true);
        setEntreprise('');
        setContact('');
        setMessage('');
        setAttemptedSubmit(false);
        setErrors({});
        setTimeout(() => {setSuccess(false);}, 10000);
      }
    }catch (error) {
      setFail(true);
      setTimeout(() => {setFail(false);}, 10000);
      return;
    }

  }
    return (
    <div className="contact-container">
      <h2 className="contact-title">Contactez nous</h2>
      <p className="contact-description">Pour nous contacter, veuillez remplir le questionnaire ci-dessous!</p>

      {success && (
        <div className="success-banner">
          <p>Votre message a été envoyé avec succès!</p>
          <p>Nous vous contacterons dans moins de <b>24 heures</b></p>
        </div>
      )}

      {fail && (
        <div className="error-banner">
          <p>Une erreur est survenue lors de l'envoi de votre message.</p>
          <p>Veuillez réessayer plus tard.</p>
        </div>
      )}

      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <div className="form-group">
          <label htmlFor="name">Entreprise: </label>
          <input id="name" name="name" type="text" placeholder="Le nom de votre entreprise" value={entreprise} onChange={handleEntrepriseChange} aria-invalid={!!errors.entreprise} aria-describedby={errors.entreprise ? "entreprise-error" : undefined}/>
          {errors.entreprise && <small className="error" id="entreprise-error">{errors.entreprise}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Courriel: </label>
          <input id="email" name="email" type="email" placeholder="contact@example.com" value={contact} onChange={handleContactChange} aria-invalid={!!errors.contact} aria-describedby={errors.contact ? "contact-error" : undefined}/>
          {errors.contact && <small className="error" id="contact-error">{errors.contact}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="message">Message: </label>
          <textarea id="message" name="message" maxLength={1000} placeholder="Decrivez les besoins de votre entreprise..." value={message} onChange={handleMessageChange} aria-invalid={!!errors.message} aria-describedby={errors.message ? "message-error" : undefined}/>
          {errors.message && <small className="error" id="message-error">{errors.message}</small>}
          <br />
          <small>{message.length} / 1000</small>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={attemptedSubmit && Object.keys(errors).length > 0}>Envoyer</button>
        </div>
      </form>
    </div>
  );
}

export default Contact;